<div red-group [attr.state]="state" [attr.redDisabled]="disabled">
    <ng-content></ng-content>
</div>
